import { render } from "./PlateKeyboard.vue?vue&type=template&id=1650577d&scoped=true"
import script from "./PlateKeyboard.vue?vue&type=script&lang=js"
export * from "./PlateKeyboard.vue?vue&type=script&lang=js"

import "./PlateKeyboard.vue?vue&type=style&index=0&id=1650577d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1650577d"]])

export default __exports__